import { BarChart3, MessageSquare, Users } from 'lucide-react';
import { RealScreen } from '@/components/marketing/roleKit';

/**
 * Tutors Real Screen 1: roster. Columns mirror the real dashboard card: name, completed-session
 * count, first-session date, and a message action.
 */
const STUDENTS = [
  { name: 'Alex M.', done: 12, since: 'Since Feb' },
  { name: 'Jamie L.', done: 7, since: 'Since Mar' },
  { name: 'Ryan K.', done: 2, since: 'Since last week' },
] as const;

export function StudentRosterSection() {
  return (
    <RealScreen
      id="section-roster"
      audience="tutors"
      layout="rail-left"
      heading="Your students, in one list"
      lede="Everyone you have taught, with how many sessions you have done together."
      callouts={[
        { icon: Users, title: 'History per student', body: 'Completed sessions and the date of your first one, on every card.' },
        { icon: MessageSquare, title: 'Message from the list', body: 'Open a chat in one click. A Mentara admin is a read-only observer in every student and tutor chat.' },
        { icon: BarChart3, title: 'Their SAT results', body: 'For students you teach, see their SAT results, and assign a diagnostic or a practice set.' },
      ]}
      caption="Example tutor dashboard, students list."
    >
      <div className="overflow-hidden rounded-xl border bg-background">
        <div className="border-b px-4 py-3">
          <p className="text-sm font-semibold">Your students</p>
        </div>
        <ul className="divide-y">
          {STUDENTS.map((s) => (
            <li key={s.name} className="flex items-center gap-3 px-4 py-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sky-700/10 text-sm font-semibold text-sky-800 dark:text-sky-300" aria-hidden>
                {s.name[0]}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">{s.name}</p>
                <p className="text-xs text-muted-foreground">{s.since}</p>
              </div>
              <p className="shrink-0 text-right text-sm">
                <span className="font-semibold tabular-nums">{s.done}</span>{' '}
                <span className="text-xs text-muted-foreground">sessions</span>
              </p>
              <span className="hidden shrink-0 items-center gap-1 rounded-md border px-2.5 py-1 text-xs text-muted-foreground sm:flex" aria-hidden>
                <MessageSquare className="h-3 w-3" /> Message
              </span>
            </li>
          ))}
        </ul>
      </div>
    </RealScreen>
  );
}
